import { CLICK_USING_INSURANCE_CHECKBOX } from './usingInsuranceConfirmationActions';
import { USING_INSURANCE_ERROR } from './usingInsuranceError';

const initialState = { value: true };

export default function usingInsuranceConfirmationReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case CLICK_USING_INSURANCE_CHECKBOX:
            return {
                ...state,
                error: null,
                value: action.payload.usingInsuranceConfirmation,
            };

        case USING_INSURANCE_ERROR:
            return {
                ...state,
                error: action.errorMessage,
            };

        default: {
            return state;
        }
    }
}
